import { useMemo } from 'react';
import SchedulerKPI from '../SchedulerKPI/schedulerKPI';
import { getWeekStartDayIndex } from '../../../../../../mat/js/components/Common/Helpers/SchedulerHelper';
import { DateHelper } from '@bryntum/scheduler';

const oneDayInMilliseconds = 86400000; //1000 * 60 * 60 * 24;

export default function SchedulerKPIs({ centerDate, metrics, currentKPIsTimeRange }) {
  const weekStartDayIndex = useMemo(() => getWeekStartDayIndex(), []);

  const getWeekNumber = () => {
    if (centerDate) {
      let date = DateHelper.floor(centerDate, oneDayInMilliseconds);
      if (date && !isNaN(date.getTime())) {
        //if valid date
        let [year, weekNumber] = DateHelper.getWeekNumber(date, weekStartDayIndex);
        return weekNumber;
      }
      console.error('scheduler.getWeekNumber(): date = ', date);
    }

    return null;
  };

  const getKPIsData = () => {
    let weekNumber = getWeekNumber();
    if (weekNumber !== null) {
      let { weeks } = metrics;
      let kpis = weeks?.[weekNumber];
      return kpis || null;
    }
    return null;
  };

  let items = getKPIsData();
  if (!items) {
    return null;
  }

  let KPIs = items.map((item, index) => {
    return <SchedulerKPI key={index} data={item} />;
  });

  return (
    <div className="scheduler-kpis-section">
      <div className="kpis-time-range">{currentKPIsTimeRange}</div>
      <div className="kpis-container">{KPIs}</div>
    </div>
  );
}
